import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConArticlePages: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConArticlePageMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConArticlePagesRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConDocs", null);
            } else {
                dispatch("receivingWebConArticlePages"); // สถานะ กำลังบันทึก



                const formData = new FormData();
                formData.append('article_page_group_tag', payload.article_page_group_tag);
                formData.append('article_page_type_tag', payload.article_page_type_tag);

                axios.get('/web_con_article_pages', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConArticlePages", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConArticlePages", null);
                    });

            }
        },
        loadWebConArticlePageRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConArticlePage", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConArticlePage");
                axios.get('/web_con_article_pages/' + id).then(res => {
                    dispatch("receiveWebConArticlePage", res.data);
                })
            }
        },
        updateWebConArticlePageRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConArticlePage");

            const formData = new FormData();

            formData.append('article_pages_id', payload.article_pages_id);
            formData.append('article_page_url', payload.article_page_url);
            formData.append('article_page_group_tag', payload.article_page_group_tag);
            formData.append('article_page_type_tag', payload.article_page_type_tag);

            formData.append('article_page_title_th', payload.article_page_title_th);
            formData.append('article_page_title_en', payload.article_page_title_en);
            formData.append('article_page_content_th', payload.article_page_content_th);
            formData.append('article_page_content_en', payload.article_page_content_en);

            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);


            axios.post('/update_con_article_pages', formData).then(res => {
                dispatch("updateWebConArticlePage", res.data);
            })

        },
        createWebConArticlePageRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConArticlePage");


            const formData = new FormData();
            formData.append('article_pages_id', payload.article_pages_id);
            formData.append('article_page_url', payload.article_page_url);
            formData.append('article_page_group_tag', payload.article_page_group_tag);
            formData.append('article_page_type_tag', payload.article_page_type_tag);

            formData.append('article_page_title_th', payload.article_page_title_th);
            formData.append('article_page_title_en', payload.article_page_title_en);
            formData.append('article_page_content_th', payload.article_page_content_th);
            formData.append('article_page_content_en', payload.article_page_content_en);

            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);

            axios.post('/web_con_article_pages', formData).then(res => {
                dispatch("receiveWebConArticlePage", res.data);

            })


        },
        deleteWebConArticlePageRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConArticlePage", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConArticlePage", payload);

            axios.post('/delete_con_article_pages', payload).then(res => {
                dispatch("deleteWebConArticlePage", {article_pages_id: payload.article_pages_id, res: res});
            })


        },
        receiveWebConArticlePages({commit}, payload) {
            commit("RECEIVED_DATAS", payload)
        },
        receivingWebConArticlePages({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConArticlePage({commit}, payload) {
            commit("RECEIVED_DATA", payload)
        },
        receivingWebConArticlePage({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        updateWebConArticlePage({commit}, payload) {
            commit("UPDATED_DATA", payload)
        },
        updatingWebConArticlePage({commit}) {
            commit("UPDATING_DATA") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConArticlePage({commit}, payload) {
            commit("DELETED_DATA", payload)
        },
        deletingWebConArticlePage({commit}, payload) {
            commit("DELETING_DATA", payload)
        },
        afterDeleteWebConArticlePage({commit}, payload) {
            commit("AFFTER_DELETED_DATA", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_DATAS(state, payload) {
            state.webConArticlePages = payload;
            state.isReceiving = false;

        },
        RECEIVING_DATAS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_DATA(state, payload) {


            if (payload.article_pages_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let webConArticlePageMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConArticlePageMessage: (state.webConArticlePageMessage == webConArticlePageMessage ? webConArticlePageMessage + ' ' : webConArticlePageMessage),

                });
            } else {
                let webConArticlePageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.article_pages_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConArticlePages: [...state.webConArticlePages, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConArticlePageMessage: (state.webConArticlePageMessage == webConArticlePageMessage ? webConArticlePageMessage + ' ' : webConArticlePageMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_DATA(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_DATA(state, payload) {
            let index = state.webConArticlePages.findIndex(p => p.article_pages_id === payload.article_pages_id);
            let webConArticlePageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.article_pages_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConArticlePages: state.webConArticlePages.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConArticlePageMessage: (state.webConArticlePageMessage == webConArticlePageMessage ? webConArticlePageMessage + ' ' : webConArticlePageMessage),
            })
        },
        UPDATING_DATA(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_DATA(state, payload) {


            if (payload.article_pages_id == undefined || payload.res.data.message == 'Relation') {
                let webConArticlePageMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.article_pages_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConArticlePageMessage: (state.webConArticlePageMessage == webConArticlePageMessage ? webConArticlePageMessage + ' ' : webConArticlePageMessage),

                });
            } else {
                let indexToDelete = state.webConArticlePages.findIndex(p => p.article_pages_id === payload.article_pages_id);
                let webConArticlePages = [...state.webConArticlePages];
                webConArticlePages.splice(indexToDelete, 1);
                let webConArticlePageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.article_pages_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConArticlePages: [...webConArticlePages],
                    isDeleting: false,
                    idToDelete: null,
                    webConArticlePageMessage: (state.webConArticlePageMessage == webConArticlePageMessage ? webConArticlePageMessage + ' ' : webConArticlePageMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_DATA(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.article_pages_id;
        },
        AFFTER_DELETED_DATA(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
